<template>
  <section class="col-start-2 col-end-12 row-start-5 row-end-6">
    <div id="features-container" class="pb-16 md:pt-16 xxl:px-6 container mx-auto overflow-hidden">
      <features-one/>
      <features-two/>
    </div>
  </section>
</template>

<script>
import FeaturesOne from "@/components/features/features-one/FeaturesOne";
import FeaturesTwo from "@/components/features/features-two/FeaturesTwo";

export default {
  name: "Features",
  components: {
    FeaturesOne,
    FeaturesTwo
  }
};
</script>

<style scoped>
</style>
